import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Reusable disconnect button component with consistent layout and styling.
 * Wraps the app-button component with danger variant and unlink icon.
 */
@Component({
  selector: 'app-disconnect-button',
  templateUrl: './disconnect-button.component.html',
  styleUrls: ['./disconnect-button.component.scss'],
})
export class DisconnectButtonComponent {
  /** Additional CSS classes for the button. Defaults to 'mt-3' */
  @Input() classes = 'mt-3';

  /** Custom label for the button. Defaults to translation key 'admin.store.disconnect' */
  @Input() label: string;

  /** Whether to include the row/col layout wrapper. Set to false for inline usage */
  @Input() showLayout = true;

  /** Emits when the button is clicked */
  @Output() clickEvent = new EventEmitter<void>();

  /**
   * Handles button click and emits the clickEvent
   */
  onClick(): void {
    this.clickEvent.emit();
  }
}
